import { render } from "./PositiveEyeIcon.vue?vue&type=template&id=675071b0&scoped=true"
const script = {}

import "./PositiveEyeIcon.vue?vue&type=style&index=0&id=675071b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675071b0"]])

export default __exports__